import Transition from "./Transition";
import {Power1} from "gsap";

class SingleRightInverseTransition extends Transition {

    constructor( _elem, autoplay = false ) {
        super( _elem, autoplay )
    }

    animateMasks() {
        let masks = this.elem.querySelectorAll( '.mask-inner' );
        if( window.matchMedia( '( min-width: 769px )' ).matches ) {
            for (let mask of masks) {
                // Mask Right
                if (mask.dataset.direction === 'right') {
                    this.tl.to(mask, this.maskSpeed, {
                        right: '127.8%',
                        ease: Power1.easeOut
                    }, 0);
                }
            }
        } else if( this.elem.dataset.hideTablet !== 'true' ) {
            for (let mask of masks) {
                if (mask.dataset.direction === 'right') {
                    this.tl.to(mask, this.maskSpeed, {
                        right: '146.8%',
                        ease: Power1.easeOut
                    }, 0);
                }
            }
        }
    }
}

export default SingleRightInverseTransition;